import { getErrorMessageOrDefault, unknownToError } from "@vortex/shared";
import { log } from "../../../util/log";
import StarterInfo from "../../../util/StarterInfo";
import { getSafe } from "../../../util/storeHelper";
export const generateGameStarter = (knownGames, discoveredGames, gameMode) => {
    const game = knownGames.find((g) => g.id === gameMode);
    const discoveredGame = discoveredGames[gameMode];
    if (game === undefined || discoveredGame?.path === undefined) {
        return null;
    }
    try {
        return new StarterInfo(game, discoveredGame);
    }
    catch (unknownError) {
        const err = unknownToError(unknownError);
        log("error", "failed to create game entry", {
            error: err.message,
            stack: err.stack,
        });
    }
    return null;
};
export const generateToolStarters = (knownGames, discoveredGames, discoveredTools, toolsOrder, gameMode, gameStarterId) => {
    const game = knownGames.find((g) => g.id === gameMode);
    const discoveredGame = discoveredGames[gameMode];
    if (game === undefined || discoveredGame?.path === undefined) {
        return [];
    }
    const knownTools = getSafe(game, ["supportedTools"], Array());
    const gameId = discoveredGame.id || game.id;
    const preConfTools = new Set(knownTools.map((tool) => tool.id));
    const starters = [];
    knownTools.forEach((tool) => {
        try {
            starters.push(new StarterInfo(game, discoveredGame, tool, discoveredTools[tool.id]));
        }
        catch (err) {
            log("warn", "invalid tool", { err });
        }
    });
    Object.keys(discoveredTools)
        .filter((toolId) => !preConfTools.has(toolId) && toolId !== gameStarterId)
        .sort((lhs, rhs) => {
        const tlhs = discoveredTools[lhs]?.timestamp || 0;
        const trhs = discoveredTools[rhs]?.timestamp || 0;
        return tlhs - trhs;
    })
        .forEach((toolId) => {
        try {
            starters.push(new StarterInfo(game, discoveredGame, undefined, discoveredTools[toolId]));
        }
        catch (err) {
            log("error", "tool configuration invalid", {
                gameId,
                toolId,
                error: getErrorMessageOrDefault(err),
            });
        }
    });
    const findIdx = (starter) => {
        const idx = toolsOrder.findIndex((toolId) => toolId === starter.id);
        return idx !== -1 ? idx : starters.length;
    };
    starters.sort((lhs, rhs) => findIdx(lhs) - findIdx(rhs));
    return starters;
};
